var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade","enter-active-class":"animated fadeIn","leave-active-class":"animated fadeOut","mode":"out-in"}},[(_vm.loading)?_c('div',{staticClass:"absolute bg-box-80 z-10 h-full w-full top-0 rounded-lg left-0"},[_c('div',{staticClass:"lds-ring"},[_c('div'),_c('div'),_c('div'),_c('div')])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }